import * as React from 'react'
import { useSelector } from 'react-redux'
import { Box, Typography as MIUTypography, styled } from '@mui/material'
import { DataGrid, gridClasses, esES } from '@mui/x-data-grid'
import { getFamilyTableAll } from '../../../services'
import { grey } from '@mui/material/colors'
import { getColumns } from './columns'
import Botton from '../../BottonCustom'
import { Create } from '@mui/icons-material'
import CreationModal from './CreationModal'
import DeleteFamilyModal from './DeleteFamilyModal'
import AlertCustom from '../../Alerts'
import { usePersistedState } from '../../../hooks/usePersistedState'

const styleContainer = { height: '100%', width: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }

const styleDefault = theme => ({
  color: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main}`,
  width: '100%',
  fontSize: '12px',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
})
const styleHeaderTab = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignContent: 'center',
  alignItems: 'baseline',
  ml: 4,
  mb: 1,
}

const Typography = styled(MIUTypography)(props => ({
  fontFamily: props.theme.typography.fontFamily,
  fontStyle: 'normal',
  fontSize: '1em',
  fontWeight: 650,
  lineHeight: '18px',
  color: '#6A6A6A',
  paddingBottom: 6,
  paddingTop: 6,
  textAlign: 'center',
  marginTop: 12,
  marginBottom: 3,
  height: '5%',
}))

const SpecieTable = ({ setSelectedLink, link }) => {
  const modalRef = React.useRef()
  const alertRef = React.useRef()
  const deleteModalRef = React.useRef()

  const [data, setData] = React.useState([])
  const [pageSize, setPageSize] = usePersistedState('admin.family.pageSize', 25)
  const [rowId, setRowId] = React.useState(null)

  const { isStored } = useSelector(state => state.alertsGlobal)

  const handleRequestDelete = React.useCallback(family => {
    deleteModalRef.current?.openModal(family)
  }, [])

  const columns = React.useMemo(
    () => getColumns(rowId, setRowId, handleRequestDelete),
    [rowId, handleRequestDelete],
  )

  const handleFormCreation = () => {
    modalRef.current.openModal()
  }

  const handleCellEditCommit = React.useCallback(params => {
    const { id, field, value } = params
    const parsedSingleSelectValue =
      value && typeof value === 'object' ? value.value ?? value.label ?? '' : value

    const normalizeValidationStatus = currentValue => {
      if (!currentValue) return null
      const normalized = String(currentValue).trim().toLowerCase()
      if (normalized === 'verificado') return 'verificado'
      if (normalized === 'pendiente') return 'pendiente'
      return normalized
    }

    let normalizedValue = parsedSingleSelectValue
    if (field === 'habilitado') normalizedValue = Boolean(parsedSingleSelectValue)
    if (field === 'estado_validacion')
      normalizedValue = normalizeValidationStatus(parsedSingleSelectValue)

    setData(prev =>
      prev.map(row =>
        row.id === id ? { ...row, [field]: normalizedValue } : row
      )
    )
    setRowId(id)
  }, [])

  React.useEffect(() => {
    getFamilyTableAll()
      .then(data => setData(data))
      .catch(err => console.log('Error: ', err))
  }, [])

  React.useEffect(() => {
    if (!Boolean(isStored)) return
    getFamilyTableAll()
      .then(data => {
        setData(data)
        alertRef?.current?.openAlert(true)
      })
      .catch(err => console.log('Error: ', err))
  }, [isStored])

  return (
    <Box sx={styleContainer}>
      <Box sx={styleHeaderTab}>
        <Box>
          <Typography>Administrar Familias</Typography>
        </Box>
        <Box>
          <Botton
            text="Nuevo"
            onClick={handleFormCreation}
            startIcon={<Create />}
            styleButton={styleDefault}
            size="small"
          />
        </Box>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', px: 2, display: 'flex' }}>
        <DataGrid
          rows={data}
          columns={columns}
          pageSize={pageSize}
          getRowId={row => row.id}
          rowsPerPageOptions={[25, 50, 75]}
          onPageSizeChange={newPageSize => setPageSize(newPageSize)}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          getRowSpacing={params => ({
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
          })}
          sx={{
            flex: 1,
            [`& .${gridClasses.row}`]: {
              bgcolor: grey[100],
            },
          }}
          onCellEditCommit={handleCellEditCommit}
        />
      </Box>
      <CreationModal ref={modalRef} />
      <DeleteFamilyModal ref={deleteModalRef} />
      <AlertCustom
        ref={alertRef}
        severity={isStored?.stored !== true ? 'warning' : 'success'}>
        {isStored?.stored !== true ? isStored?.message : 'Guardado exitosamente.'}
      </AlertCustom>
    </Box>
  )
}

export default SpecieTable
